export var widgetWrapperStyles={display:"flex",alignItems:"stretch",flexBasis:"auto",flexDirection:"column",flexShrink:0,position:"relative"};